import { ActionReducerMap } from '@ngrx/store';
// import * as fromPipMailing from '../../components/pip-mailing/store/pip-mailing.reducer';
import * as fromAuth from '../../auth/store/reducers/auth.reducers';
import * as fromLms from '../../components/lms-activities-process-flow/store/lms-activities.reducer';

export interface AppState {
  // pipMailing: fromPipMailing.PipMailingState;
  lms: fromLms.LmsState;
  auth: fromAuth.State;
}

export const appReducer: ActionReducerMap<AppState> = {
  // pipMailing: fromPipMailing.pipMailingReducer,
  auth: fromAuth.reducer,
  lms: fromLms.lmsReducer,
};
